import React, { useState, useEffect } from 'react';
import { X, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function NoticeBanner() {
  const [notices, setNotices] = useState([]);
  const [dismissedMap, setDismissedMap] = useState({});

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('dismissed_notices_v2') || '{}');
    setDismissedMap(stored);
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/notices/active`);
      const data = await response.json();
      setNotices(data.notices || []);
    } catch (error) {
      console.error('Error loading notices:', error);
    }
  };

  const handleDismiss = (notice) => {
    const updated = { ...dismissedMap, [notice.id]: notice.updated_at || notice.created_at || '' };
    setDismissedMap(updated);
    localStorage.setItem('dismissed_notices_v2', JSON.stringify(updated));
  };

  const activeNotices = notices.filter(notice => {
    const dismissedAt = dismissedMap[notice.id];
    if (!dismissedAt) return true;
    const noticeVersion = notice.updated_at || notice.created_at || '';
    return noticeVersion !== dismissedAt;
  });

  if (activeNotices.length === 0) return null;

  const getIcon = (type) => {
    const icons = {
      info: <Info className="w-5 h-5" />,
      warning: <AlertTriangle className="w-5 h-5" />,
      vacation: <AlertCircle className="w-5 h-5" />,
      shipping_delay: <AlertCircle className="w-5 h-5" />
    };
    return icons[type] || <Info className="w-5 h-5" />;
  };

  return (
    <div className="w-full" data-testid="notice-banner">
      {activeNotices.map((notice) => (
        <div 
          key={notice.id} 
          className="bg-red-600 text-white flex items-start gap-3 px-6 py-4 shadow-md"
          data-testid={`notice-${notice.id}`}
        >
          <div className="flex-shrink-0 mt-0.5">
            {getIcon(notice.type)}
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-lg mb-1">{notice.title}</h3>
            <p className="text-sm">{notice.message}</p>
            {notice.start_date && notice.end_date && (
              <p className="text-xs mt-2 opacity-90">
                {notice.start_date} - {notice.end_date}
              </p>
            )}
          </div>
          <button 
            onClick={() => handleDismiss(notice)}
            className="flex-shrink-0 hover:opacity-70 transition-opacity bg-white bg-opacity-20 rounded-full p-1"
            aria-label="Cerrar aviso"
            data-testid={`dismiss-notice-${notice.id}`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      ))}
    </div>
  );
}